export default "__VITE_ASSET__1ZEgtAec__"